export default __webpack_public_path__ + "static/media/feintattack9.edcbd0df.png";